import { acquireToken } from '../../auth/msal.js';
import { protectedResourcesScopes } from '../../auth/config.js';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_BFF_API}`;
const scope = protectedResourcesScopes.core;

export const getFiles = async (instance, elementType, elementId, isCommissioning = false) => {
  try {
    const accessToken = await acquireToken(instance, scope);
    const queryParams = `?isCommissioning=${isCommissioning}`;
    const { data } = await axios.get(
      `${apiUrl}/system/file/${elementType}/${elementId}${queryParams}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );
    return data;
  } catch (e) {
    throw e;
  }
};



export const saveFile = async (
  instance,
  elementType,
  elementId,
  file,
  onUploadProgress,
  isCommissioning = false,
  shouldValidate = false,
  fieldsToValidate = [],
  task = null,
  stage = null
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("isCommissioning", isCommissioning);
    formData.append("shouldValidate", shouldValidate);
    formData.append("fieldsToValidate", JSON.stringify(fieldsToValidate));
    formData.append("task", JSON.stringify(task));
    formData.append("stage", JSON.stringify(stage));

    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.post(
      `${apiUrl}/system/file/${elementType}/${elementId}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      }
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};


export const deleteFile = async (instance, elementType, elementId, fileName, task = null, stage = null) => {
  try {
    const accessToken = await acquireToken(instance, scope);
    const { data } = await axios.delete(`${apiUrl}/system/file/${elementType}/${elementId}`, {
      params: {
        fileName,
        task,
        stage,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (err) {
    throw err;
  }
};
